module.exports = __webpack_public_path__ + "img/everything-financial.3825056f.jpg";